if('function' === typeof importScripts) {
  importScripts("https://js.pusher.com/beams/service-worker.js");
}